export default __webpack_public_path__ + "static/media/banner-new.56fab7f3.gif";